export default function escapeNonLatin1(text) {
    return text.replace(new RegExp("[^\x00-\x7F]", "g"), txt => `&#${txt.charCodeAt(0)};`);
}
